import { createSelector } from '@reduxjs/toolkit';

import mapValues from 'lodash/mapValues';
import { Permission, AnyUser } from '../../../general/model';
import { Page } from '../../models/page';
import { RootSelector } from '../../models/rootSelector';
import { AppShape } from './model';

export const getApp = (x: { app: AppShape }) => x.app;

export const getInitialized = createSelector(getApp, (app) => app.initialized);

export const getSearchParams = createSelector(getApp, (x) => x.searchParams);

export const getNodeId: RootSelector<number | null> = createSelector(getApp, (app) => app.nodeId);
export const getShareID: RootSelector<string | null> = createSelector(getApp, (app) => app.shareId);
export const getPage: RootSelector<Page | null> = createSelector(getApp, (app) => app.page);
export const getUser = createSelector(getApp, (app) => app.user);
export const getPermissions: RootSelector<Permission[]> = createSelector(getUser, (user) => {
  return user?.permissions ?? [];
});
type PermissionsMap = { [key in Permission]: boolean };
export const getPermissionsIndexed: RootSelector<PermissionsMap> = createSelector(
  getPermissions,
  (permissions) => mapValues(Permission, (p) => permissions.includes(p)),
);
export const getScenarios: RootSelector<any> = createSelector(getApp, (a) => a.scenarios);
export const getUsers: RootSelector<AnyUser[] | null> = createSelector(getApp, (app) => app.users);

export const getSettings = createSelector(getApp, (app) => app.settings);

export const getSlowNetwork = createSelector(getApp, (app) => app.slowNetwork);
